import type React from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from '@iconify/react';
import { EmptyState } from '@heroui-pro/react';
import { getNodeTestIdProp } from '@/utils';

/** Nothing listed at all: every barcode scans, or was kept as it is. */
export const BarcodeIssuesEmpty: React.FC = () => {
    const { t } = useTranslation('pages');

    return (
        <EmptyState {...getNodeTestIdProp('barcode-issues-empty')}>
            <EmptyState.Header>
                <EmptyState.Media variant="icon">
                    <Icon aria-hidden icon="gravity-ui:circle-check" />
                </EmptyState.Media>
                <EmptyState.Title>
                    {t('products.barcodeIssues.empty.title')}
                </EmptyState.Title>
                <EmptyState.Description>
                    {t('products.barcodeIssues.empty.description')}
                </EmptyState.Description>
            </EmptyState.Header>
        </EmptyState>
    );
};
